import { useEffect, useRef } from "react"

// TODO this should have a window sized div that covers the whole screen, and then a smaller div that is the actual popup. This will allow us to collect events even if they user has clicked on something other element with a click handler.
const useOutsideClick = (callback: () => boolean, enabled: boolean = true) => {
  const ref = useRef(null)
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  useEffect(() => {
    if (!enabled) return

    const handleClick = (event: MouseEvent) => {
      if (ref.current && !(ref.current as any).contains(event.target)) {
        if (callbackRef.current()) {
          event.preventDefault()
          event.stopPropagation()
        }
      }
    }

    // Defer attach so the same click that opened the menu doesn't immediately close it
    const frame = window.requestAnimationFrame(() => {
      document.addEventListener("click", handleClick, true)
    })

    return () => {
      window.cancelAnimationFrame(frame)
      document.removeEventListener("click", handleClick, true)
    }
  }, [enabled])

  return ref
}

export default useOutsideClick
